var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"bastards",rawName:"v-bastards"}],class:[
        'button-save btn btn-c--secondary fs-21 fs-lh-26 text-bold text-left',
        _vm.themeClass,
        { 'is-disabled': _vm.isDisabled }
    ],domProps:{"innerHTML":_vm._s(_vm.labelHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }